import { connect } from 'react-redux'
import School from './school'
import { setSchool } from '../../../redux/fsu-teacher.actions'
import { getSelectedSchool } from '../../../redux/fsu-teacher.selectors'

const mapStateToProps = (state, { id }) => {
  const selectedSchool = getSelectedSchool(state)
  if (selectedSchool && selectedSchool.id === id)
    return {
      selected: true
    }
}

const mapDispatchToProps = (dispatch, { id, title }) => ({
  onClick: () => dispatch(setSchool({ id, title }))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(School)
